import { render, staticRenderFns } from "./errorDiv.vue?vue&type=template&id=9050fb62&"
import script from "./errorDiv.vue?vue&type=script&lang=ts&"
export * from "./errorDiv.vue?vue&type=script&lang=ts&"
import style0 from "./errorDiv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports